// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skill-code-name-tooltip-anchor {
  display: inline-flex;
  cursor: help;
}

.skill-code-name-tooltip-anchor:focus-visible {
  outline: 2px solid rgba(148, 163, 184, 0.55);
  outline-offset: 2px;
  border-radius: 999px;
}

.skill-code-name-tooltip {
  position: fixed;
  z-index: 10036;
  padding: 0.28rem 0.48rem;
  border: 1px solid rgba(148, 163, 184, 0.42);
  border-radius: 0.35rem;
  background: rgba(15, 23, 42, 0.94);
  color: #f8fafc;
  font-size: 0.68rem;
  line-height: 1.2;
  white-space: nowrap;
  pointer-events: auto;
  transform: translateX(-50%);
  box-shadow: 0 5px 14px rgba(2, 6, 23, 0.26);
}
`, "",{"version":3,"sources":["webpack://./src/components/report/SkillCodeNameTooltip.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,2CAA2C;EAC3C,sBAAsB;EACtB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,2CAA2C;AAC7C","sourcesContent":[".skill-code-name-tooltip-anchor {\n  display: inline-flex;\n  cursor: help;\n}\n\n.skill-code-name-tooltip-anchor:focus-visible {\n  outline: 2px solid rgba(148, 163, 184, 0.55);\n  outline-offset: 2px;\n  border-radius: 999px;\n}\n\n.skill-code-name-tooltip {\n  position: fixed;\n  z-index: 10036;\n  padding: 0.28rem 0.48rem;\n  border: 1px solid rgba(148, 163, 184, 0.42);\n  border-radius: 0.35rem;\n  background: rgba(15, 23, 42, 0.94);\n  color: #f8fafc;\n  font-size: 0.68rem;\n  line-height: 1.2;\n  white-space: nowrap;\n  pointer-events: auto;\n  transform: translateX(-50%);\n  box-shadow: 0 5px 14px rgba(2, 6, 23, 0.26);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
